<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { changePassword } from "./api";

  // In forced mode (seeded/default admin) the dialog can't be dismissed.
  export let forced = false;

  const dispatch = createEventDispatcher<{ close: void; done: void }>();

  let oldPw = "", newPw = "", confirmPw = "", error = "", busy = false;

  function maybeClose(): void {
    if (!forced) dispatch("close");
  }

  async function submit(): Promise<void> {
    error = "";
    if (newPw.length < 6) { error = "new password too short (min 6 characters)"; return; }
    if (newPw !== confirmPw) { error = "passwords don't match"; return; }
    busy = true;
    try { await changePassword(oldPw, newPw); dispatch("done"); }
    catch (e) { error = String(e).replace(/^Error:\s*/, ""); }
    finally { busy = false; }
  }
</script>

<div class="modal-mask" on:click|self={maybeClose}>
  <form class="modal narrow" on:submit|preventDefault={submit}>
    <div class="modal-head">
      <h2>Change password</h2>
      {#if !forced}<button type="button" on:click={() => dispatch("close")}>Close</button>{/if}
    </div>
    {#if forced}
      <div class="nudge">You must set a new password before continuing.</div>
    {/if}
    {#if error}<div class="modal-error">{error}</div>{/if}
    <label>Current password<input type="password" bind:value={oldPw} /></label>
    <label>New password<input type="password" bind:value={newPw} /></label>
    <label>Confirm new password<input type="password" bind:value={confirmPw} /></label>
    <button class="primary" type="submit" disabled={busy || !oldPw || !newPw}>Save</button>
  </form>
</div>
